module.exports = __webpack_public_path__ + "media/withdrawal/en-af0e8f84.pdf";